class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    if ( ! this.classList.contains('don-t-duplicate') ) {

      document.getElementById('FacetFiltersFormMobile').innerHTML = document.getElementById('FacetFiltersForm').innerHTML;
      document.getElementById('FacetFiltersFormMobile').addEventListener('input', this.debouncedOnSubmit.bind(this));
      document.getElementById('FacetFiltersFormMobile').querySelectorAll('.facets__item').forEach(elm=>{
        const id = elm.querySelector('input').id;
        elm.querySelector('label').setAttribute('for', `mobile-${id}`);
        elm.querySelector('input').id = `mobile-${id}`;
      }); 
      document.getElementById('FacetFiltersFormMobile').querySelectorAll('.collection-filters__item').forEach(elm=>{
        const id = elm.querySelector('select').id;
        elm.querySelector('label').setAttribute('for', `mobile-${id}`);
        elm.querySelector('select').id = `mobile-${id}`;
      });

      document.getElementById('FacetFiltersFormMobile').querySelector('.active-facets').classList.remove('active-facets-desktop')
      document.getElementById('FacetFiltersFormMobile').querySelector('.active-facets').classList.add('active-facets-mobile');
    }

  }

  // UglyXmas 07-10-2026: maatfilter alleen op voorraad. Is er een maat (variantoptie) gekozen, dan gaat het verborgen
  // voorraadfilter mee, zodat Shopify alleen truien toont waarvan díe maat op voorraad is; zonder maat gaat het eraf
  // (uitverkochte truien blijven dan gewoon zichtbaar). Zelfde regel als het scriptje in de head van layout/theme.liquid.
  static uxVoorraad(params) {
    const heeftMaat = Array.from(params.keys()).some(k => k.indexOf('filter.v.option.') === 0);
    if ( heeftMaat ) params.set('filter.v.availability', '1');
    else params.delete('filter.v.availability');
    return params;
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.getElementById('main-collection-product-grid').classList.add('loading');
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGrid(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGrid(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('CollectionProductGrid').innerHTML;
    document.getElementById('CollectionProductGrid').innerHTML = innerHTML;
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const countEl = parsed.getElementById('CollectionProductCount');
    if ( countEl ) {
      document.getElementById('CollectionProductCount').innerHTML = countEl.innerHTML;
    }
    // UglyXmas 15-09-2026: aantal op de knop onderaan de mobiele filterpop-up bijwerken
    const uxCount = parsed.getElementById('UxResultsCount');
    if ( uxCount ) FacetFiltersForm.updateFilterDoneButton(parseInt(uxCount.dataset.count));
  }

  static updateFilterDoneButton(count) {
    const btn = document.querySelector('[data-js-filter-klaar]');
    if ( ! btn || isNaN(count) ) return;
    btn.textContent = count == 1 ? btn.dataset.labelOne : btn.dataset.labelOther.replace('__AANTAL__', count);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      if ( event && event.target.closest('.js-filter') ) {
        return element.dataset.index === event.target.closest('.js-filter').dataset.index;
      }
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    FacetFiltersForm.syncInputsFromServer(parsedHTML);
    FacetFiltersForm.syncFilterSummaries();
    // UglyXmas 15-09-2026: op mobiel het paneel waarin net gekozen is open laten staan
    if ( event && event.target.closest('#FacetFiltersFormMobile .js-filter') ) {
      event.target.closest('.js-filter').open = true;
    }
  }

  // UglyXmas 15-09-2026: aangevinkte stand van alle filtervakjes (desktop én mobiel) gelijkzetten aan wat Shopify terugstuurt,
  // zodat de keuze nooit "verdwijnt" na het herladen van de sectie (gezien op iPhone)
  static syncInputsFromServer(parsedHTML) {
    const sources = parsedHTML.querySelectorAll('#FacetFiltersForm input[type="checkbox"]');
    sources.forEach(src => {
      document.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(src.name)}"][value="${CSS.escape(src.value)}"]`).forEach(tgt => {
        tgt.checked = src.checked;
        FacetFiltersForm.markChecked(tgt);
      });
    });
  }

  static markChecked(input) {
    const label = input.closest('label');
    if ( label ) label.classList.toggle('is-checked', input.checked);
  }

  // UglyXmas 15-09-2026: gekozen waarden in de filterknop zelf tonen ("Maat: L, XL") en de knop markeren
  static syncFilterSummaries() {
    document.querySelectorAll('.js-filter').forEach(details => {
      const labels = Array.from(details.querySelectorAll('input:checked')).map(input => {
        const label = input.closest('label');
        return label ? label.textContent.replace(/\s*\(\d+\)\s*$/, '').trim() : input.value;
      });
      const target = details.querySelector('.facets__summary-active');
      if ( target ) target.textContent = labels.length ? `: ${labels.join(', ')}` : '';
      details.classList.toggle('facets__disclosure--active', labels.length > 0);
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector('.active-facets');
      if (!activeFacetsElement) return;
      if ( document.querySelector(selector) )
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const countElementSelectors = ['.facets__selected'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);
      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }


  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);
    // UglyXmas 02-10-2026: maatfilter-vakjes (ux_maat, zie snippets/ux-maatfilter.liquid) omzetten naar de echte filterwaarden
    params.delete('ux_maat');
    form.querySelectorAll('input[name="ux_maat"]:checked').forEach(inp => {
      const p = inp.dataset.uxMaatParam;
      (inp.dataset.uxMaatWaarden || '').split('||').forEach(w => {
        if ( p && w && ! params.getAll(p).includes(w) ) params.append(p, w);
      });
    });
    FacetFiltersForm.uxVoorraad(params);
    FacetFiltersForm.renderPage(params.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    FacetFiltersForm.renderPage(FacetFiltersForm.uxVoorraad(new URL(event.currentTarget.href).searchParams).toString());
  }

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

FacetFiltersForm.syncFilterSummaries();
document.querySelectorAll('.facets__form input[type="checkbox"]').forEach(input => FacetFiltersForm.markChecked(input));

// UglyXmas 15-09-2026: directe visuele terugkoppeling bij aan-/uitvinken (vóór het herladen), plus 'change' als vangnet voor browsers
// die op een checkbox geen 'input'-event geven; het sorteerveld op mobiel toont de gekozen optie in een eigen tekstveld
document.addEventListener('change', (e) => {
  const t = e.target;
  if ( t.matches('.facets__form input[type="checkbox"]') ) {
    FacetFiltersForm.markChecked(t);
    FacetFiltersForm.syncFilterSummaries();
    const details = t.closest('.js-filter'); if ( details ) details.open = true;
    const form = t.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if ( form && form.debouncedOnSubmit ) form.debouncedOnSubmit(e);
  }
  if ( t.matches('.collection-filters__sort') ) {
    const waarde = t.closest('.collection-filters__field')?.querySelector('.ux-sort-waarde');
    if ( waarde ) waarde.textContent = t.options[t.selectedIndex].text;
  }
});

// UglyXmas 15-09-2026 (ronde 4, iPhone): in de mobiele pop-up staan de filterpanelen altijd open en schakelen de maat-chips via JS.
// Op iOS Safari klapte een tik op een chip (label + checkbox binnen <details>) het paneel dicht zonder het vakje aan te vinken.
(() => {
  const mobile = document.getElementById('FacetFiltersFormMobile');
  if ( ! mobile ) return;
  const houdOpen = () => {
    mobile.querySelectorAll('.js-filter').forEach(details => {
      details.open = true;
      if ( ! details.dataset.uxOpenGuard ) {
        details.dataset.uxOpenGuard = '1';
        details.addEventListener('toggle', () => { if ( ! details.open ) details.open = true; });
      }
    });
  };
  houdOpen();
  new MutationObserver(houdOpen).observe(mobile, { childList: true, subtree: true });
  mobile.addEventListener('click', (e) => {
    const label = e.target.closest('.facet-checkbox');
    if ( ! label ) return;
    e.preventDefault();
    e.stopPropagation();
    const input = label.querySelector('input[type="checkbox"]');
    if ( ! input || input.disabled ) return;
    input.checked = ! input.checked;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);
})();

// UglyXmas 15-09-2026: knop "Toon X producten" onderaan de mobiele filterpop-up sluit de pop-up (filters zijn al live toegepast)
document.querySelectorAll('[data-js-filter-klaar]').forEach(btn => {
  btn.addEventListener('click', () => {
    const sidebar = document.getElementById('site-filters-sidebar');
    if ( sidebar && typeof sidebar.hide == 'function' ) sidebar.hide();
  });
});

// UglyXmas 07-10-2026: links die een filter weghalen (maat-pil met kruisje, "Wissen") laden een nieuwe pagina.
// Vlak voor het klikken de link rechtzetten volgens uxVoorraad, zodat er geen omweg via het head-scriptje nodig is.
document.addEventListener('click', (e) => {
  const a = e.target.closest && e.target.closest('a.js-facet-remove');
  if ( ! a || ! a.href ) return;
  try {
    const u = new URL(a.href, window.location.href);
    const oud = u.search.replace(/^\?/, '');
    const nieuw = FacetFiltersForm.uxVoorraad(new URLSearchParams(u.search)).toString();
    if ( nieuw !== oud ) { u.search = nieuw; a.href = u.toString(); }
  } catch (err) {}
}, true);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);